import styled from 'styled-components';
import { white, blue, grayDarker } from '@bufferapp/ui/style/colors';
import { CARD_PADDING, LINE_HEIGHT } from '../config';

export const DeleteIdeaContainer = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  right: 12px;
  top: 12px;
  transition: all 150ms ease-out;

  button {
    width: 32px;
    height: 32px;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const IdeaStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${CARD_PADDING}px;
  box-sizing: border-box;
  overflow: hidden;
  background: ${white};
  border-radius: 8px;
  cursor: pointer;
  transition: all 150ms ease-in-out;
  position: relative;
  justify-content: center;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);

  ${DeleteIdeaContainer} {
    opacity: 0;
    pointer-events: none;
  }

  img,
  p,
  .play_icon,
  .maxed_out {
    transition: opacity 250ms ease-out;
    transition: height 150ms ease-out;
  }

  &:hover {
    box-shadow: 0px 8px 8px 0px rgba(61, 61, 61, 0.16);

    ${DeleteIdeaContainer} {
      opacity: 1;
      pointer-events: all;
    }
  }

  > div {
    flex-shrink: 1;
  }

  p {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: ${LINE_HEIGHT}px;
    text-align: left;
    overflow-wrap: anywhere;
    height: fit-content;
    color: ${grayDarker};

    b {
      font-weight: normal;
      color: ${blue};
    }
  }

  .maxed_out {
    height: 100%;
    position: relative;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
`;

export const IdeaStyledMedia = styled(IdeaStyled)`
  padding: 0;
  .media {
    position: relative;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    background-size: cover;
    background-position: center;
  }

  .play_icon {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    position: absolute;
    left: 16px;
    bottom: 16px;
    background-color: rgba(54, 62, 70, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      fill: ${white};
      width: 16px;
      height: 16px;
    }
  }
  &:hover > ${IdeaStyled} {
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  }
`;

export const TwoColumnsMediaGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 4px;

  > .media {
    height: auto;
  }
`;

export const TwoRowsMediaGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 4px;

  > .media {
    height: auto;
  }
`;

export const TwoColumnsTwoRowsMediaGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 4px;

  > .media {
    height: auto;
  }
`;

export const SimpleMediaGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-gap: 4px;
`;

export const IdeaMixedMediaContainer = styled(IdeaStyledMedia).attrs({
  as: 'div',
})`
  filter: none;
  background-color: transparent;
  gap: 0;
  border-radius: 0;
  margin: 0;
`;
